module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-600italic.348af8b.woff";